export const legendTooltipPlugin = (isExport: boolean): any => ({
  id: 'legendTooltip',
  afterEvent(chart: any, args: any): void {
    if (isExport) {
      return;
    }

    const { event } = args;
    if (event.type === 'mousemove') {
      const legendItems = chart.legend.legendItems;
      const legendHitBoxes = chart.legend.legendHitBoxes;

      for (let i = 0; i < legendHitBoxes.length; i++) {
        const box = legendHitBoxes[i];
        if (
          event.x >= box.left &&
          event.x <= box.left + box.width &&
          event.y >= box.top &&
          event.y <= box.top + box.height
        ) {
          chart.canvas.title =
            (legendItems[i].originalText || legendItems[i].text) + legendItems[i].valueString;
          return;
        }
      }

      chart.canvas.title = '';
    }
  },
});
